import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M24 42.1q-.75 0-1.225-.475-.475-.475-.475-1.225V12.25L19 15.6q-.5.5-1.2.5t-1.2-.5q-.5-.55-.5-1.225t.5-1.175L22.8 7q.3-.3.575-.4.275-.1.625-.1t.625.1q.275.1.575.4l6.2 6.2q.5.5.5 1.175t-.5 1.225q-.5.5-1.2.5t-1.2-.5l-3.3-3.35V40.4q0 .75-.475 1.225-.475.475-1.225.475Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }